import { useEffect } from "react";
import { X } from "lucide-react";

export default function Modal({ open, onClose, title, children, footer, width = "max-w-lg" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onMouseDown={onClose}
    >
      <div
        className={`w-full ${width} bg-[#162032] border border-[#23334D] rounded-2xl shadow-2xl max-h-[92vh] flex flex-col`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#23334D]">
          <h3 className="font-head font-semibold text-lg text-white">{title}</h3>
          <button onClick={onClose} data-testid="modal-close" className="text-[#6B7280] hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto">{children}</div>
        {footer && <div className="px-5 py-4 border-t border-[#23334D] flex justify-end gap-3">{footer}</div>}
      </div>
    </div>
  );
}

export const Field = ({ label, children }) => (
  <div>
    {label && (
      <label className="text-xs font-semibold text-[#9CA3AF] uppercase tracking-wide">{label}</label>
    )}
    <div className="mt-1.5">{children}</div>
  </div>
);

export const inputCls =
  "w-full bg-[#0B0F17] border border-[#23334D] rounded-lg px-3 py-2.5 text-sm text-white outline-none focus:border-[#10B981] placeholder:text-[#4B5563]";

export const btnPrimary =
  "bg-[#10B981] hover:bg-[#059669] text-[#06221a] font-semibold px-4 py-2.5 rounded-lg transition-colors disabled:opacity-60";
export const btnGhost =
  "bg-[#1E2C45] hover:bg-[#263657] text-[#9CA3AF] hover:text-white font-medium px-4 py-2.5 rounded-lg transition-colors";
export const btnDanger =
  "bg-[#EF4444]/15 hover:bg-[#EF4444]/25 text-[#EF4444] font-medium px-4 py-2.5 rounded-lg transition-colors";
